var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,10 H41 V38 H7 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,15 A5,5 0,1 0,13,25 A5,5 0,1 0,13,15",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,34 L20,23 L27,30 L32,25 L39,34 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35,7 A5,5 0,1 0,35,17 A5,5 0,1 0,35,7",
    fill: "#FFD000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3,8.3 V15.7 H34.3 V13 H31.8 V11.2 H34.3 V8.3 Z",
    fill: "#0D0D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessPhotoIcon);
export default __webpack_public_path__ + "static/media/p4r_business_photo_icon.08f2bed4cadfa0c25179af23e2862b19.svg";
export { ForwardRef as ReactComponent };